import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useHistory, useParams } from "react-router-dom";

// ─── Constants ────────────────────────────────────────────────────────────────
const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const CANAL_COLORS = {
  whatsapp:   { bg: "#F0FDF4", text: "#166534", border: "#bbf7d0" },
  mail:       { bg: "#EEF2FF", text: "#3730A3", border: "#c7d2fe" },
  llamada:    { bg: "#FFF7ED", text: "#9A3412", border: "#fed7aa" },
  presencial: { bg: "#fdf0f6", text: "#9f0059", border: "#f5c0de" },
};

const ESTADO_COLORS = {
  activa:    { bg: "#F0FDF4", text: "#166534", border: "#bbf7d0" },
  inactiva:  { bg: "#f3f4f6", text: "#374151", border: "#d1d5db" },
  prospecto: { bg: "#EEF2FF", text: "#3730A3", border: "#c7d2fe" },
  perdida:   { bg: "#FFF1F2", text: "#9f1239", border: "#fecdd3" },
};

const todayISO = () => new Date().toISOString().split("T")[0];

const formatFecha = (str) => {
  if (!str) return "—";
  const [y, m, d] = str.split(/[T ]/)[0].split("-");
  return `${d}/${m}/${y}`;
};

const getUserId = () => {
  try {
    const u = localStorage.getItem("user");
    return u ? JSON.parse(u).id : null;
  } catch {
    return null;
  }
};

// ─── Styles ───────────────────────────────────────────────────────────────────
const S = {
  page: {
    minHeight: "100vh",
    background: "#f7f4f6",
    padding: "28px 20px",
    fontFamily: "'Segoe UI', system-ui, sans-serif",
    color: "#121212",
  },
  inner: { maxWidth: 1100, margin: "0 auto" },

  // Header
  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 12,
    marginBottom: 24,
  },
  headerLeft: { display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" },
  backBtn: {
    background: "none",
    border: "none",
    fontSize: 22,
    color: "#9f0059",
    cursor: "pointer",
    padding: "0 4px",
    lineHeight: 1,
  },
  title: { fontSize: 22, fontWeight: 700, color: "#121212", margin: 0 },
  badge: (colors) => ({
    display: "inline-block",
    padding: "3px 10px",
    borderRadius: 20,
    fontSize: 12,
    fontWeight: 600,
    background: colors?.bg || "#f3f4f6",
    color: colors?.text || "#374151",
    border: `1.5px solid ${colors?.border || "#d1d5db"}`,
  }),
  newQuoteBtn: {
    padding: "9px 18px",
    background: "#166534",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    fontSize: 13,
    fontWeight: 600,
    cursor: "pointer",
  },

  // Tabs
  tabRow: { display: "flex", gap: 0, marginBottom: 24 },
  tabBtn: (active) => ({
    padding: "9px 28px",
    border: "1.5px solid #9f0059",
    borderRadius: 0,
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    background: active ? "#9f0059" : "#fff",
    color: active ? "#fff" : "#9f0059",
    transition: "background 0.15s, color 0.15s",
  }),
  tabBtnFirst: (active) => ({
    padding: "9px 28px",
    border: "1.5px solid #9f0059",
    borderRadius: "8px 0 0 8px",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    background: active ? "#9f0059" : "#fff",
    color: active ? "#fff" : "#9f0059",
    transition: "background 0.15s, color 0.15s",
  }),
  tabBtnLast: (active) => ({
    padding: "9px 28px",
    border: "1.5px solid #9f0059",
    borderRadius: "0 8px 8px 0",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    background: active ? "#9f0059" : "#fff",
    color: active ? "#fff" : "#9f0059",
    transition: "background 0.15s, color 0.15s",
  }),

  // Cards
  card: {
    background: "#fff",
    borderRadius: 10,
    padding: 14,
    boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
    border: "1.5px solid #f0e6ec",
  },
  cardGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
    gap: 14,
    marginBottom: 24,
  },
  contactName: { fontWeight: 700, fontSize: 15, marginBottom: 4 },
  contactCargo: { fontSize: 13, color: "#555", marginBottom: 6 },
  contactInfo: { fontSize: 13, color: "#333", marginBottom: 3 },
  contactLink: { color: "#9f0059", textDecoration: "none", fontSize: 13 },

  // Collapsible add contact
  toggleAddBtn: {
    padding: "8px 18px",
    background: "#fff",
    border: "1.5px solid #9f0059",
    borderRadius: 8,
    color: "#9f0059",
    fontWeight: 600,
    fontSize: 13,
    cursor: "pointer",
    marginBottom: 16,
  },

  // Form
  form: {
    background: "#fff",
    borderRadius: 10,
    padding: 20,
    boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
    border: "1.5px solid #f0e6ec",
    marginBottom: 24,
  },
  formTitle: { fontWeight: 700, fontSize: 15, marginBottom: 16, color: "#9f0059" },
  formRow: { display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 12 },
  formGroup: { display: "flex", flexDirection: "column", gap: 4, flex: "1 1 180px" },
  label: { fontSize: 12, fontWeight: 600, color: "#555" },
  input: {
    padding: "8px 10px",
    border: "1.5px solid #e0d6dc",
    borderRadius: 7,
    fontSize: 13,
    color: "#121212",
    outline: "none",
    background: "#fafafa",
  },
  select: {
    padding: "8px 10px",
    border: "1.5px solid #e0d6dc",
    borderRadius: 7,
    fontSize: 13,
    color: "#121212",
    outline: "none",
    background: "#fafafa",
    cursor: "pointer",
  },
  textarea: {
    padding: "8px 10px",
    border: "1.5px solid #e0d6dc",
    borderRadius: 7,
    fontSize: 13,
    color: "#121212",
    outline: "none",
    background: "#fafafa",
    resize: "vertical",
    minHeight: 70,
    fontFamily: "inherit",
  },
  submitBtn: {
    padding: "9px 22px",
    background: "#9f0059",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    fontSize: 13,
    fontWeight: 600,
    cursor: "pointer",
    marginTop: 4,
  },

  // Timeline
  timelineWrap: { position: "relative", paddingLeft: 28, marginBottom: 28 },
  timelineLine: {
    position: "absolute",
    left: 4,
    top: 0,
    bottom: 0,
    width: 2,
    background: "#e0d6dc",
    borderRadius: 2,
  },
  timelineItem: { position: "relative", marginBottom: 18 },
  timelineDot: (tipo) => ({
    position: "absolute",
    left: -24,
    top: 16,
    width: 10,
    height: 10,
    borderRadius: "50%",
    background: tipo === "cotizacion" ? "#1d4ed8" : "#9f0059",
    border: "2px solid #fff",
    boxShadow: `0 0 0 1.5px ${tipo === "cotizacion" ? "#1d4ed8" : "#9f0059"}`,
  }),
  interactionCard: {
    background: "#fff",
    borderRadius: 10,
    padding: 14,
    boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
    border: "1.5px solid #f0e6ec",
  },
  cotizacionCard: {
    background: "#f0f4ff",
    borderRadius: 10,
    padding: 14,
    boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
    border: "1.5px solid #c7d2fe",
  },
  interactionFecha: { fontWeight: 700, fontSize: 13, marginBottom: 6 },
  interactionMeta: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",
    marginBottom: 8,
  },
  interactionContacto: { fontSize: 13, color: "#9f0059", fontWeight: 600 },
  interactionUsuario: { fontSize: 12, color: "#888" },
  interactionResumen: { fontSize: 14, color: "#121212", marginBottom: 8, lineHeight: 1.5 },
  proximoPasoBox: {
    background: "#fffbeb",
    border: "1px solid #fde68a",
    borderRadius: 6,
    padding: "7px 10px",
    fontSize: 13,
    color: "#92400e",
    marginTop: 6,
  },
  proximoPasoLabel: { fontWeight: 700, marginRight: 4 },
  verCotizacionBtn: {
    marginTop: 10,
    padding: "5px 14px",
    background: "#1d4ed8",
    color: "#fff",
    border: "none",
    borderRadius: 6,
    fontSize: 12,
    fontWeight: 600,
    cursor: "pointer",
  },

  // Empty state
  empty: { color: "#999", fontSize: 13, padding: "16px 0" },
};

// ─── Canal Badge ─────────────────────────────────────────────────────────────
const CanalBadge = ({ canal }) => {
  const c = CANAL_COLORS[canal] || { bg: "#f3f4f6", text: "#374151", border: "#d1d5db" };
  return (
    <span
      style={{
        display: "inline-block",
        padding: "2px 9px",
        borderRadius: 20,
        fontSize: 11,
        fontWeight: 600,
        background: c.bg,
        color: c.text,
        border: `1.5px solid ${c.border}`,
        textTransform: "capitalize",
      }}
    >
      {canal || "—"}
    </span>
  );
};


const TIPO_TAREA_ICONS = {
  llamada: "📞", visita: "🏢", enviar_cotizacion: "📄",
  seguimiento: "🔄", administrativo: "📋", otro: "📌",
};

const PRIORIDAD_COLORS = {
  alta:  { bg: "#fef2f2", color: "#dc2626" },
  media: { bg: "#fffbeb", color: "#b45309" },
  baja:  { bg: "#f0fdf4", color: "#16a34a" },
};

// ─── Main Component ───────────────────────────────────────────────────────────
const CRMDetalleCuenta = () => {
  const { cuentaId } = useParams();
  const history = useHistory();

  const [cuenta, setCuenta] = useState(null);
  const [contactos, setContactos] = useState([]);
  const [interacciones, setInteracciones] = useState([]);
  const [tareas, setTareas] = useState([]);
  const [activeTab, setActiveTab] = useState("contactos");
  const [loadingInit, setLoadingInit] = useState(true);
  const [loadingTareas, setLoadingTareas] = useState(false);

  // Add/Edit contact form state
  const [showAddContacto, setShowAddContacto] = useState(false);
  const [editContacto, setEditContacto] = useState(null);
  const [contactoForm, setContactoForm] = useState({
    id: "", nombre: "", cargo: "", mail: "", telefono: "", canal_preferido: "whatsapp", notas: "",
  });
  const [savingContacto, setSavingContacto] = useState(false);
  const [confirmDeleteContacto, setConfirmDeleteContacto] = useState(false);

  // Add-interaccion form state
  const [interaccionForm, setInteraccionForm] = useState({
    fecha: todayISO(),
    canal: "whatsapp",
    contacto_id: "",
    resumen: "",
    proximo_paso: "",
  });
  const [savingInteraccion, setSavingInteraccion] = useState(false);

  // Edit-interaccion modal state
  const [editingInteraccion, setEditingInteraccion] = useState(null);
  const [confirmDeleteInteraccion, setConfirmDeleteInteraccion] = useState(false);
  const [savingEditInteraccion, setSavingEditInteraccion] = useState(false);

  // Quick-add tarea state
  const [showAddTarea, setShowAddTarea] = useState(false);
  const [tareaForm, setTareaForm] = useState({
    titulo: "", tipo: "seguimiento", prioridad: "media",
    vencimiento: "", descripcion: "",
  });
  const [savingTarea, setSavingTarea] = useState(false);

  // Filtro de interacciones por contacto
  const [filtroContacto, setFiltroContacto] = useState("");

  // Catálogo de canales (BD - dimensión administrable)
  const [canales, setCanales] = useState([]);
  useEffect(() => {
    axios.get(`${BASE}/buscar_canales.php`)
      .then((r) => { if (Array.isArray(r.data)) setCanales(r.data); })
      .catch(() => {});
  }, []);

  // ── Load data ──────────────────────────────────────────────────────────────
  const loadContactos = async () => {
    try {
      const res = await axios.post(`${BASE}/crm_contactos_listar.php`, new URLSearchParams({ cliente_id: cuentaId }));
      setContactos(Array.isArray(res.data) ? res.data : []);
    } catch {
      toast.error("Error al cargar contactos");
    }
  };

  const loadInteracciones = async () => {
    try {
      const res = await axios.post(`${BASE}/crm_interacciones_listar.php`, new URLSearchParams({ cliente_id: cuentaId }));
      setInteracciones(Array.isArray(res.data) ? res.data : []);
    } catch {
      toast.error("Error al cargar interacciones");
    }
  };

  const loadCuenta = async () => {
    try {
      const res = await axios.post(`${BASE}/crm_cuentas_listar.php`, new URLSearchParams({}));
      const list = Array.isArray(res.data) ? res.data : [];
      setCuenta(list.find((c) => String(c.id) === String(cuentaId)) || null);
    } catch {
      toast.error("Error al cargar la cuenta");
    }
  };

  const loadTareas = async () => {
    setLoadingTareas(true);
    try {
      const fd = new FormData();
      fd.append("cliente_id", cuentaId);
      fd.append("estado", "todas");
      const res = await axios.post(`${BASE}/tareas_listar.php`, fd);
      setTareas(Array.isArray(res.data) ? res.data : []);
    } catch {
      toast.error("Error al cargar tareas");
    } finally {
      setLoadingTareas(false);
    }
  };

  useEffect(() => {
    setLoadingInit(true);
    Promise.all([loadContactos(), loadInteracciones(), loadCuenta()]).finally(() =>
      setLoadingInit(false)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cuentaId]);

  // Lazy-load oportunidades / tareas when tab is first opened
  useEffect(() => {
    if (activeTab === "tareas" && tareas.length === 0) loadTareas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  // ── Contact form ───────────────────────────────────────────────────────────
  const handleContactoChange = (e) => {
    setContactoForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleContactoSubmit = async (e) => {
    e.preventDefault();
    if (!contactoForm.nombre.trim()) {
      toast.warning("El nombre es requerido");
      return;
    }
    setSavingContacto(true);
    try {
      const fdC = new FormData();
      Object.entries({ ...contactoForm, cliente_id: cuentaId }).forEach(([k, v]) => fdC.append(k, v ?? ""));
      await axios.post(`${BASE}/crm_contactos_guardar.php`, fdC);
      toast.success(editContacto ? "Contacto actualizado" : "Contacto guardado");
      setContactoForm({ id: "", nombre: "", cargo: "", mail: "", telefono: "", canal_preferido: "whatsapp", notas: "" });
      setShowAddContacto(false);
      setEditContacto(null);
      loadContactos();
    } catch {
      toast.error("Error al guardar contacto");
    } finally {
      setSavingContacto(false);
    }
  };

  const handleDeleteContacto = async () => {
    try {
      const fd = new FormData();
      fd.append("id", contactoForm.id);
      const res = await axios.post(`${BASE}/crm_contactos_eliminar.php`, fd);
      if (res.data?.success) {
        toast.success("Contacto eliminado");
        setContactoForm({ id: "", nombre: "", cargo: "", mail: "", telefono: "", canal_preferido: "whatsapp", notas: "" });
        setShowAddContacto(false);
        setEditContacto(null);
        setConfirmDeleteContacto(false);
        loadContactos();
      } else {
        toast.error(res.data?.mensaje || "No se pudo eliminar");
        setConfirmDeleteContacto(false);
      }
    } catch {
      toast.error("Error de conexión");
      setConfirmDeleteContacto(false);
    }
  };

  // ── Interaccion form ───────────────────────────────────────────────────────
  const handleInteraccionChange = (e) => {
    setInteraccionForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleInteraccionSubmit = async (e) => {
    e.preventDefault();
    if (!interaccionForm.contacto_id) {
      toast.warning("Seleccioná un contacto para la interacción");
      return;
    }
    if (!interaccionForm.resumen.trim()) {
      toast.warning("El resumen es requerido");
      return;
    }
    setSavingInteraccion(true);
    const usuario_id = getUserId();
    try {
      const fdI = new FormData();
      Object.entries({
        ...interaccionForm,
        cliente_id: cuentaId,
        usuario_id: usuario_id ?? "",
        contacto_id: interaccionForm.contacto_id || "",
      }).forEach(([k, v]) => fdI.append(k, v ?? ""));
      await axios.post(`${BASE}/crm_interacciones_guardar.php`, fdI);
      toast.success("Interacción registrada");
      setInteraccionForm({ fecha: todayISO(), canal: "whatsapp", contacto_id: "", resumen: "", proximo_paso: "" });
      loadInteracciones();
    } catch {
      toast.error("Error al guardar interacción");
    } finally {
      setSavingInteraccion(false);
    }
  };

  // ── Edit / delete interaccion ──────────────────────────────────────────────
  const handleEditInteraccionSubmit = async (e) => {
    e.preventDefault();
    if (!editingInteraccion.resumen?.trim()) {
      toast.warning("El resumen es requerido");
      return;
    }
    setSavingEditInteraccion(true);
    try {
      const fd = new FormData();
      fd.append("id",           editingInteraccion.id);
      fd.append("canal",        editingInteraccion.canal || "");
      fd.append("fecha",        editingInteraccion.fecha?.split("T")[0] || "");
      fd.append("resumen",      editingInteraccion.resumen || "");
      fd.append("proximo_paso", editingInteraccion.proximo_paso || "");
      fd.append("contacto_id",  editingInteraccion.contacto_id || "");
      const res = await axios.post(`${BASE}/crm_interacciones_guardar.php`, fd);
      if (res.data?.success) {
        toast.success("Interacción actualizada");
        setEditingInteraccion(null);
        setConfirmDeleteInteraccion(false);
        loadInteracciones();
      } else {
        toast.error(res.data?.mensaje || "Error al guardar");
      }
    } catch {
      toast.error("Error de conexión");
    } finally {
      setSavingEditInteraccion(false);
    }
  };

  const handleDeleteInteraccion = async () => {
    try {
      const fd = new FormData();
      fd.append("id", editingInteraccion.id);
      const res = await axios.post(`${BASE}/crm_interacciones_eliminar.php`, fd);
      if (res.data?.success) {
        toast.success("Interacción eliminada");
        setEditingInteraccion(null);
        setConfirmDeleteInteraccion(false);
        loadInteracciones();
      } else {
        toast.error(res.data?.mensaje || "No se pudo eliminar");
        setConfirmDeleteInteraccion(false);
      }
    } catch {
      toast.error("Error de conexión");
      setConfirmDeleteInteraccion(false);
    }
  };

  // ── Quick-add tarea ────────────────────────────────────────────────────────
  const handleTareaChange = (e) =>
    setTareaForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleTareaSubmit = async (e) => {
    e.preventDefault();
    if (!tareaForm.titulo.trim() || !tareaForm.vencimiento) {
      toast.warning("Título y vencimiento son requeridos");
      return;
    }
    const uid = getUserId();
    if (!uid) { toast.error("Iniciá sesión para crear tareas"); return; }
    setSavingTarea(true);
    try {
      const fd = new FormData();
      Object.entries({
        ...tareaForm,
        cliente_id: cuentaId,
        usuario_id: uid,
        creado_por: uid,
      }).forEach(([k, v]) => fd.append(k, v ?? ""));
      const res = await axios.post(`${BASE}/tareas_guardar.php`, fd);
      if (res.data?.success) {
        toast.success("Tarea creada");
        setTareaForm({ titulo: "", tipo: "seguimiento", prioridad: "media", vencimiento: "", descripcion: "" });
        setShowAddTarea(false);
        loadTareas();
      } else {
        toast.error(res.data?.mensaje || "Error al crear la tarea");
      }
    } catch {
      toast.error("Error de conexión");
    } finally {
      setSavingTarea(false);
    }
  };

  const completarTarea = async (tarea) => {
    const fd = new FormData();
    Object.entries({ ...tarea, estado: "hecha" }).forEach(([k, v]) => fd.append(k, v ?? ""));
    try {
      await axios.post(`${BASE}/tareas_guardar.php`, fd);
      toast.success("Tarea completada");
      loadTareas();
    } catch {
      toast.error("Error al actualizar la tarea");
    }
  };

  // ── Render ─────────────────────────────────────────────────────────────────
  const estadoColors =
    cuenta?.estado ? ESTADO_COLORS[cuenta.estado.toLowerCase()] || ESTADO_COLORS.inactiva : null;

  return (
    <div style={S.page}>
      <div style={S.inner}>

        {/* ── Header ── */}
        <div style={S.headerRow}>
          <div style={S.headerLeft}>
            <button style={S.backBtn} onClick={() => history.goBack()} title="Volver">
              ←
            </button>
            <h1 style={S.title}>
              {loadingInit ? "Cargando…" : cuenta ? cuenta.nombre : `Cuenta #${cuentaId}`}
            </h1>
            {cuenta?.estado && (
              <span style={S.badge(estadoColors)}>
                {cuenta.estado}
              </span>
            )}
          </div>
          <button
            style={S.newQuoteBtn}
            onClick={() => history.push("/dashboard/newquotation")}
          >
            + Nueva cotización
          </button>
        </div>

        {/* ── Links de empresa (web, Instagram, LinkedIn) ── */}
        {(cuenta?.web || cuenta?.instagram || cuenta?.linkedin) && (
          <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 16, fontSize: 13 }}>
            {cuenta.web && (
              <a
                href={cuenta.web.startsWith("http") ? cuenta.web : "https://" + cuenta.web}
                target="_blank" rel="noreferrer"
                style={{ color: "#9f0059", textDecoration: "none", display: "flex", alignItems: "center", gap: 4 }}
              >
                🌐 {cuenta.web}
              </a>
            )}
            {cuenta.instagram && (
              <a
                href={cuenta.instagram.startsWith("http") ? cuenta.instagram : "https://instagram.com/" + cuenta.instagram.replace("@","")}
                target="_blank" rel="noreferrer"
                style={{ color: "#9f0059", textDecoration: "none", display: "flex", alignItems: "center", gap: 4 }}
              >
                📷 Instagram
              </a>
            )}
            {cuenta.linkedin && (
              <a
                href={cuenta.linkedin.startsWith("http") ? cuenta.linkedin : "https://" + cuenta.linkedin}
                target="_blank" rel="noreferrer"
                style={{ color: "#9f0059", textDecoration: "none", display: "flex", alignItems: "center", gap: 4 }}
              >
                💼 LinkedIn
              </a>
            )}
          </div>
        )}

        {/* ── Panel "Origen del cliente: prospección" ── */}
        {cuenta?.prospecto_id_origen && (
          <div style={{
            background: "linear-gradient(90deg, #fdf0f6 0%, #fff 100%)",
            border: "1.5px solid #f0e6ec",
            borderLeft: "4px solid #9f0059",
            borderRadius: 10,
            padding: "12px 18px",
            marginBottom: 18,
            display: "flex", justifyContent: "space-between", alignItems: "center",
            fontSize: 13, color: "#444",
          }}>
            <div>
              <span style={{ fontWeight: 700, color: "#9f0059", marginRight: 8 }}>
                🎯 Cliente originado en prospección
              </span>
              {cuenta.origen_prospeccion && <>desde <strong>{cuenta.origen_prospeccion}</strong> · </>}
              convertido el <strong>{formatFecha(cuenta.fecha_conversion_desde_prospecto)}</strong>
            </div>
            <button
              onClick={() => history.push(`/dashboard/crm/prospeccion/detalle/${cuenta.prospecto_id_origen}`)}
              style={{
                background: "none", border: "1px solid #9f0059", color: "#9f0059",
                padding: "5px 12px", borderRadius: 6,
                fontSize: 11, fontWeight: 700, cursor: "pointer",
              }}
            >
              Ver historial de prospección →
            </button>
          </div>
        )}

        {/* ── Tabs ── */}
        <div style={S.tabRow}>
          <button
            style={S.tabBtnFirst(activeTab === "contactos")}
            onClick={() => setActiveTab("contactos")}
          >
            Contactos
          </button>
          <button
            style={S.tabBtn(activeTab === "interacciones")}
            onClick={() => setActiveTab("interacciones")}
          >
            Interacciones
          </button>
          <button
            style={S.tabBtnLast(activeTab === "tareas")}
            onClick={() => setActiveTab("tareas")}
          >
            Tareas{tareas.filter(t => t.estado !== "hecha" && t.estado !== "cancelada").length > 0 && (
              <span style={{ marginLeft: 6, background: "rgba(255,255,255,0.3)", borderRadius: 10, padding: "1px 7px", fontSize: 11 }}>
                {tareas.filter(t => t.estado !== "hecha" && t.estado !== "cancelada").length}
              </span>
            )}
          </button>
        </div>

        {/* ── Tab: Tareas ── */}
        {activeTab === "tareas" && (
          <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, flexWrap: "wrap", gap: 8 }}>
              <span style={{ fontSize: 13, color: "#888" }}>
                {tareas.filter(t => t.estado !== "hecha" && t.estado !== "cancelada").length} tarea{tareas.filter(t => t.estado !== "hecha" && t.estado !== "cancelada").length !== 1 ? "s" : ""} pendientes
              </span>
              <button
                style={{ ...S.toggleAddBtn, marginBottom: 0 }}
                onClick={() => setShowAddTarea((v) => !v)}
              >
                {showAddTarea ? "▲ Cancelar" : "＋ Nueva tarea"}
              </button>
            </div>

            {showAddTarea && (
              <form style={{ ...S.form, marginBottom: 20 }} onSubmit={handleTareaSubmit}>
                <div style={S.formTitle}>Nueva tarea para esta cuenta</div>
                <div style={S.formRow}>
                  <div style={{ ...S.formGroup, flex: "2 1 240px" }}>
                    <label style={S.label}>Título *</label>
                    <input style={S.input} name="titulo" value={tareaForm.titulo} onChange={handleTareaChange} placeholder="¿Qué hay que hacer?" required />
                  </div>
                  <div style={S.formGroup}>
                    <label style={S.label}>Tipo</label>
                    <select style={S.select} name="tipo" value={tareaForm.tipo} onChange={handleTareaChange}>
                      <option value="llamada">Llamada</option>
                      <option value="visita">Visita</option>
                      <option value="enviar_cotizacion">Enviar cotización</option>
                      <option value="seguimiento">Seguimiento</option>
                      <option value="administrativo">Administrativo</option>
                      <option value="otro">Otro</option>
                    </select>
                  </div>
                  <div style={S.formGroup}>
                    <label style={S.label}>Prioridad</label>
                    <select style={S.select} name="prioridad" value={tareaForm.prioridad} onChange={handleTareaChange}>
                      <option value="alta">Alta</option>
                      <option value="media">Media</option>
                      <option value="baja">Baja</option>
                    </select>
                  </div>
                  <div style={S.formGroup}>
                    <label style={S.label}>Vencimiento *</label>
                    <input style={S.input} type="datetime-local" name="vencimiento" value={tareaForm.vencimiento} onChange={handleTareaChange} required />
                  </div>
                </div>
                <div style={S.formRow}>
                  <div style={{ ...S.formGroup, flex: "1 1 100%" }}>
                    <label style={S.label}>Descripción</label>
                    <textarea style={{ ...S.textarea, minHeight: 50 }} name="descripcion" value={tareaForm.descripcion} onChange={handleTareaChange} placeholder="Detalles opcionales…" />
                  </div>
                </div>
                <button style={S.submitBtn} type="submit" disabled={savingTarea}>
                  {savingTarea ? "Guardando…" : "Crear tarea"}
                </button>
              </form>
            )}

            {loadingTareas ? (
              <p style={S.empty}>Cargando tareas…</p>
            ) : tareas.length === 0 ? (
              <p style={S.empty}>No hay tareas para esta cuenta.</p>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {tareas.map((t) => {
                  const pr = PRIORIDAD_COLORS[t.prioridad] || PRIORIDAD_COLORS.media;
                  const vencida = t.estado !== "hecha" && t.estado !== "cancelada" && t.horas_para_vencer != null && Number(t.horas_para_vencer) < 0;
                  const hecha = t.estado === "hecha";
                  return (
                    <div key={t.id} style={{
                      ...S.card,
                      display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap",
                      opacity: hecha ? 0.6 : 1,
                      borderLeft: `3px solid ${vencida ? "#dc2626" : hecha ? "#16a34a" : "#9f0059"}`,
                    }}>
                      {/* Checkbox */}
                      {!hecha && (
                        <button
                          title="Marcar como hecha"
                          onClick={() => completarTarea(t)}
                          style={{
                            width: 22, height: 22, borderRadius: "50%", border: "2px solid #9f0059",
                            background: "none", cursor: "pointer", flexShrink: 0, display: "flex",
                            alignItems: "center", justifyContent: "center", padding: 0,
                          }}
                        >
                          {t.estado === "en_curso" && <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#9f0059", display: "block" }} />}
                        </button>
                      )}
                      {hecha && (
                        <span style={{ width: 22, height: 22, borderRadius: "50%", background: "#f0fdf4", border: "2px solid #16a34a", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, flexShrink: 0 }}>✓</span>
                      )}

                      <div style={{ flex: "1 1 180px" }}>
                        <div style={{ fontWeight: 700, fontSize: 14, color: vencida ? "#dc2626" : "#121212", textDecoration: hecha ? "line-through" : "none" }}>
                          {TIPO_TAREA_ICONS[t.tipo] || "📌"} {t.titulo}
                        </div>
                        <div style={{ fontSize: 12, color: "#888", marginTop: 2 }}>
                          {t.usuario_nombre && `→ ${t.usuario_nombre} · `}
                          Vence: {t.vencimiento ? new Date(t.vencimiento).toLocaleDateString("es-AR", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—"}
                          {vencida && <span style={{ color: "#dc2626", fontWeight: 700 }}> · VENCIDA</span>}
                        </div>
                      </div>

                      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                        <span style={{ padding: "2px 9px", borderRadius: 20, fontSize: 11, fontWeight: 700, background: pr.bg, color: pr.color }}>
                          {t.prioridad}
                        </span>
                        <span style={{ padding: "2px 9px", borderRadius: 20, fontSize: 11, fontWeight: 600, background: "#f7f4f6", color: "#555", textTransform: "capitalize" }}>
                          {t.estado.replace("_", " ")}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* ── Tab: Contactos ── */}
        {activeTab === "contactos" && (
          <div>
            {contactos.length === 0 && !loadingInit ? (
              <p style={S.empty}>No hay contactos registrados para esta cuenta.</p>
            ) : (
              <div style={S.cardGrid}>
                {contactos.map((c) => (
                  <div key={c.id} style={S.card}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 6 }}>
                      <div style={S.contactName}>{c.nombre}</div>
                      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        {c.canal_preferido && <CanalBadge canal={c.canal_preferido} />}
                        <button
                          style={{
                            background: "none", border: "1.5px solid #9f0059", borderRadius: 6,
                            color: "#9f0059", fontSize: 11, fontWeight: 700, cursor: "pointer",
                            padding: "2px 10px",
                          }}
                          onClick={() => {
                            setEditContacto(c);
                            setContactoForm({
                              id: c.id, nombre: c.nombre || "", cargo: c.cargo || "",
                              mail: c.mail || "", telefono: c.telefono || "",
                              canal_preferido: c.canal_preferido || "whatsapp", notas: c.notas || "",
                            });
                            setShowAddContacto(true);
                            setTimeout(() => document.getElementById("contacto-form")?.scrollIntoView({ behavior: "smooth" }), 100);
                          }}
                        >
                          Editar
                        </button>
                      </div>
                    </div>
                    {c.cargo && <div style={S.contactCargo}>{c.cargo}</div>}
                    {c.mail && (
                      <div style={S.contactInfo}>
                        <a href={`mailto:${c.mail}`} style={S.contactLink}>
                          {c.mail}
                        </a>
                      </div>
                    )}
                    {c.telefono && (
                      <div style={S.contactInfo}>{c.telefono}</div>
                    )}
                    {c.notas && (
                      <div style={{ fontSize: 12, color: "#888", marginTop: 6, fontStyle: "italic" }}>
                        {c.notas}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}

            {/* Toggle add contacto */}
            <button
              style={S.toggleAddBtn}
              onClick={() => {
                if (showAddContacto) {
                  setShowAddContacto(false);
                  setEditContacto(null);
                  setContactoForm({ id: "", nombre: "", cargo: "", mail: "", telefono: "", canal_preferido: "whatsapp", notas: "" });
                } else {
                  setShowAddContacto(true);
                }
              }}
            >
              {showAddContacto ? "▲ Cancelar" : "＋ Agregar contacto"}
            </button>

            {showAddContacto && (
              <form id="contacto-form" style={S.form} onSubmit={handleContactoSubmit}>
                <div style={S.formTitle}>{editContacto ? "Editar contacto" : "Nuevo contacto"}</div>
                <div style={S.formRow}>
                  <div style={S.formGroup}>
                    <label style={S.label}>Nombre *</label>
                    <input
                      style={S.input}
                      name="nombre"
                      value={contactoForm.nombre}
                      onChange={handleContactoChange}
                      placeholder="Nombre completo"
                      required
                    />
                  </div>
                  <div style={S.formGroup}>
                    <label style={S.label}>Cargo</label>
                    <input
                      style={S.input}
                      name="cargo"
                      value={contactoForm.cargo}
                      onChange={handleContactoChange}
                      placeholder="Ej: Gerente de compras"
                    />
                  </div>
                </div>
                <div style={S.formRow}>
                  <div style={S.formGroup}>
                    <label style={S.label}>Mail</label>
                    <input
                      style={S.input}
                      name="mail"
                      type="email"
                      value={contactoForm.mail}
                      onChange={handleContactoChange}
                      placeholder="correo@ejemplo.com"
                    />
                  </div>
                  <div style={S.formGroup}>
                    <label style={S.label}>Teléfono</label>
                    <input
                      style={S.input}
                      name="telefono"
                      value={contactoForm.telefono}
                      onChange={handleContactoChange}
                      placeholder="+54 11 1234-5678"
                    />
                  </div>
                  <div style={S.formGroup}>
                    <label style={S.label}>Canal preferido</label>
                    <select
                      style={S.select}
                      name="canal_preferido"
                      value={contactoForm.canal_preferido}
                      onChange={handleContactoChange}
                    >
                      {canales.map((c) => (
                        <option key={c.id} value={c.nombre.toLowerCase()}>{c.nombre}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div style={S.formRow}>
                  <div style={{ ...S.formGroup, flex: "1 1 100%" }}>
                    <label style={S.label}>Notas</label>
                    <textarea
                      style={S.textarea}
                      name="notas"
                      value={contactoForm.notas}
                      onChange={handleContactoChange}
                      placeholder="Notas adicionales…"
                    />
                  </div>
                </div>
                {/* Footer: delete on left, save on right */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10, marginTop: 4 }}>
                  <div>
                    {contactoForm.id && !confirmDeleteContacto && (
                      <button
                        type="button"
                        onClick={() => setConfirmDeleteContacto(true)}
                        style={{
                          padding: "8px 16px",
                          background: "none",
                          border: "1.5px solid #dc2626",
                          borderRadius: 8,
                          color: "#dc2626",
                          fontSize: 13,
                          fontWeight: 600,
                          cursor: "pointer",
                        }}
                      >
                        Eliminar contacto
                      </button>
                    )}
                    {contactoForm.id && confirmDeleteContacto && (
                      <div style={{
                        display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap",
                        background: "#fef2f2", border: "1.5px solid #fecaca",
                        borderRadius: 8, padding: "8px 14px",
                      }}>
                        <span style={{ fontSize: 13, color: "#dc2626", fontWeight: 600 }}>
                          ¿Confirmar eliminación?
                        </span>
                        <button
                          type="button"
                          onClick={handleDeleteContacto}
                          style={{
                            padding: "5px 14px", background: "#dc2626", color: "#fff",
                            border: "none", borderRadius: 6, fontSize: 13, fontWeight: 700, cursor: "pointer",
                          }}
                        >
                          Sí, eliminar
                        </button>
                        <button
                          type="button"
                          onClick={() => setConfirmDeleteContacto(false)}
                          style={{
                            padding: "5px 14px", background: "none", color: "#555",
                            border: "1.5px solid #d1d5db", borderRadius: 6, fontSize: 13, cursor: "pointer",
                          }}
                        >
                          Cancelar
                        </button>
                      </div>
                    )}
                  </div>
                  <button style={S.submitBtn} type="submit" disabled={savingContacto}>
                    {savingContacto ? "Guardando…" : "Guardar contacto"}
                  </button>
                </div>
              </form>
            )}
          </div>
        )}

        {/* ── Tab: Interacciones ── */}
        {activeTab === "interacciones" && (
          <div>
            {/* Filtro por contacto */}
            {interacciones.length > 0 && (
              <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 18 }}>
                <span style={{ fontSize: 12, fontWeight: 600, color: "#555" }}>Filtrar por contacto:</span>
                <button
                  onClick={() => setFiltroContacto("")}
                  style={{
                    padding: "4px 14px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer",
                    border: "1.5px solid #9f0059",
                    background: filtroContacto === "" ? "#9f0059" : "#fff",
                    color: filtroContacto === "" ? "#fff" : "#9f0059",
                  }}
                >
                  Todos
                </button>
                {contactos
                  .filter((c) => interacciones.some((i) => String(i.contacto_id) === String(c.id)))
                  .map((c) => (
                    <button
                      key={c.id}
                      onClick={() => setFiltroContacto(String(c.id))}
                      style={{
                        padding: "4px 14px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer",
                        border: "1.5px solid #9f0059",
                        background: filtroContacto === String(c.id) ? "#9f0059" : "#fff",
                        color: filtroContacto === String(c.id) ? "#fff" : "#9f0059",
                      }}
                    >
                      {c.nombre}
                    </button>
                  ))}
              </div>
            )}

            {/* Timeline */}
            {interacciones.length === 0 && !loadingInit ? (
              <p style={S.empty}>No hay interacciones registradas para esta cuenta.</p>
            ) : (
              <div style={S.timelineWrap}>
                <div style={S.timelineLine} />
                {interacciones
                  .filter((item) => filtroContacto === "" || String(item.contacto_id) === filtroContacto)
                  .map((item) => (
                  <div key={`${item.tipo}-${item.id}`} style={S.timelineItem}>
                    <div style={S.timelineDot(item.tipo)} />

                    {item.tipo === "cotizacion" ? (
                      /* ── Cotización card ── */
                      <div style={S.cotizacionCard}>
                        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6, flexWrap: "wrap" }}>
                          <span style={S.interactionFecha}>{formatFecha(item.fecha)}</span>
                          <span style={{
                            display: "inline-block", padding: "2px 9px", borderRadius: 20,
                            fontSize: 11, fontWeight: 600, background: "#dbeafe",
                            color: "#1d4ed8", border: "1.5px solid #bfdbfe",
                          }}>
                            📋 Cotización #{item.orden_id}
                          </span>
                          {item.estado_orden && (
                            <span style={{
                              display: "inline-block", padding: "2px 9px", borderRadius: 20,
                              fontSize: 11, fontWeight: 600, background: "#f0fdf4",
                              color: "#166534", border: "1.5px solid #bbf7d0",
                              textTransform: "capitalize",
                            }}>
                              {item.estado_orden}
                            </span>
                          )}
                        </div>
                        <div style={S.interactionMeta}>
                          {item.contacto_nombre && (
                            <span style={S.interactionContacto}>{item.contacto_nombre}</span>
                          )}
                          {item.usuario_nombre && (
                            <span style={S.interactionUsuario}>por {item.usuario_nombre}</span>
                          )}
                        </div>
                        <div style={{ display: "flex", alignItems: "baseline", gap: 16, flexWrap: "wrap", marginBottom: 4 }}>
                          {item.proveedor_nombre && (
                            <span style={{ fontSize: 13, color: "#555" }}>
                              Proveedor: <strong>{item.proveedor_nombre}</strong>
                            </span>
                          )}
                          {item.monto_total != null && (
                            <span style={{ fontSize: 15, fontWeight: 700, color: "#166534" }}>
                              $ {parseFloat(item.monto_total).toLocaleString("es-AR", { minimumFractionDigits: 2 })}
                            </span>
                          )}
                        </div>
                        {item.resumen && (
                          <div style={{ fontSize: 13, color: "#555", marginTop: 4, fontStyle: "italic" }}>
                            {item.resumen}
                          </div>
                        )}
                        <button
                          style={S.verCotizacionBtn}
                          onClick={() => history.push(`/dashboard/cotizaciones`)}
                        >
                          Ver cotización →
                        </button>
                      </div>
                    ) : (
                      /* ── Interacción regular ── */
                      <div style={{
                        ...S.interactionCard,
                        ...(item.origen_prospeccion == 1 || item.origen_prospeccion === "1" ? { borderLeft: "3px solid #9f0059", background: "#fdf0f615" } : {}),
                      }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, marginBottom: 6, flexWrap: "wrap" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                            <span style={S.interactionFecha}>{formatFecha(item.fecha)}</span>
                            {item.canal && <CanalBadge canal={item.canal} />}
                            {(item.origen_prospeccion == 1 || item.origen_prospeccion === "1") && (
                              <span style={{
                                display: "inline-block", padding: "2px 9px", borderRadius: 20,
                                fontSize: 10, fontWeight: 700, background: "#fdf0f6",
                                color: "#9f0059", border: "1.5px solid #f0c8de",
                                letterSpacing: "0.05em",
                              }}>
                                🎯 PROSPECCIÓN
                              </span>
                            )}
                          </div>
                          <button
                            onClick={() => { setEditingInteraccion({ ...item }); setConfirmDeleteInteraccion(false); }}
                            style={{ background: "none", border: "1.5px solid #d1d5db", borderRadius: 6, color: "#555", fontSize: 11, fontWeight: 600, cursor: "pointer", padding: "2px 10px", flexShrink: 0 }}
                          >
                            Editar
                          </button>
                        </div>
                        <div style={S.interactionMeta}>
                          {item.contacto_nombre && (
                            <span style={S.interactionContacto}>{item.contacto_nombre}</span>
                          )}
                          {item.usuario_nombre && (
                            <span style={S.interactionUsuario}>por {item.usuario_nombre}</span>
                          )}
                        </div>
                        {item.resumen && (
                          <div style={S.interactionResumen}>{item.resumen}</div>
                        )}
                        {item.proximo_paso && (
                          <div style={S.proximoPasoBox}>
                            <span style={S.proximoPasoLabel}>Próximo paso:</span>
                            {item.proximo_paso}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}

            {/* Register interaction form */}
            <form style={S.form} onSubmit={handleInteraccionSubmit}>
              <div style={S.formTitle}>Registrar interacción</div>
              <div style={S.formRow}>
                <div style={S.formGroup}>
                  <label style={S.label}>Fecha *</label>
                  <input
                    style={S.input}
                    type="date"
                    name="fecha"
                    value={interaccionForm.fecha}
                    onChange={handleInteraccionChange}
                    required
                  />
                </div>
                <div style={S.formGroup}>
                  <label style={S.label}>Canal</label>
                  <select
                    style={S.select}
                    name="canal"
                    value={interaccionForm.canal}
                    onChange={handleInteraccionChange}
                  >
                    {canales.map((c) => (
                      <option key={c.id} value={c.nombre.toLowerCase()}>{c.nombre}</option>
                    ))}
                  </select>
                </div>
                <div style={S.formGroup}>
                  <label style={S.label}>Contacto *</label>
                  <select
                    style={{
                      ...S.select,
                      borderColor: !interaccionForm.contacto_id ? "#f59e0b" : "#e0d6dc",
                    }}
                    name="contacto_id"
                    value={interaccionForm.contacto_id}
                    onChange={handleInteraccionChange}
                    required
                  >
                    <option value="">
                      {contactos.length === 0 ? "Sin contactos cargados" : "Seleccioná un contacto"}
                    </option>
                    {contactos.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.nombre}{c.cargo ? ` — ${c.cargo}` : ""}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div style={S.formRow}>
                <div style={{ ...S.formGroup, flex: "1 1 100%" }}>
                  <label style={S.label}>Resumen *</label>
                  <textarea
                    style={S.textarea}
                    name="resumen"
                    value={interaccionForm.resumen}
                    onChange={handleInteraccionChange}
                    placeholder="Describí brevemente la interacción…"
                    required
                  />
                </div>
              </div>
              <div style={S.formRow}>
                <div style={{ ...S.formGroup, flex: "1 1 100%" }}>
                  <label style={S.label}>Próximo paso</label>
                  <textarea
                    style={{ ...S.textarea, minHeight: 50 }}
                    name="proximo_paso"
                    value={interaccionForm.proximo_paso}
                    onChange={handleInteraccionChange}
                    placeholder="¿Qué sigue? (opcional)"
                  />
                </div>
              </div>
              <button style={S.submitBtn} type="submit" disabled={savingInteraccion}>
                {savingInteraccion ? "Guardando…" : "Registrar interacción"}
              </button>
            </form>
          </div>
        )}
      </div>

      {/* ── Modal editar interacción ── */}
      {editingInteraccion && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.35)", zIndex: 999, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
          onClick={(e) => { if (e.target === e.currentTarget) { setEditingInteraccion(null); setConfirmDeleteInteraccion(false); } }}
        >
          <div style={{ background: "#fff", borderRadius: 14, padding: 28, maxWidth: 560, width: "100%", boxShadow: "0 8px 40px rgba(0,0,0,0.18)", maxHeight: "90vh", overflowY: "auto" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
              <div style={{ fontWeight: 700, fontSize: 17, color: "#9f0059" }}>Editar interacción</div>
              <button onClick={() => { setEditingInteraccion(null); setConfirmDeleteInteraccion(false); }} style={{ background: "none", border: "none", fontSize: 22, cursor: "pointer", color: "#888", lineHeight: 1, padding: "0 4px" }}>×</button>
            </div>
            <form onSubmit={handleEditInteraccionSubmit}>
              <div style={S.formRow}>
                <div style={S.formGroup}>
                  <label style={S.label}>Fecha *</label>
                  <input style={S.input} type="date" value={editingInteraccion.fecha?.split("T")[0] || ""} onChange={e => setEditingInteraccion(p => ({ ...p, fecha: e.target.value }))} required />
                </div>
                <div style={S.formGroup}>
                  <label style={S.label}>Canal</label>
                  <select style={S.select} value={editingInteraccion.canal || ""} onChange={e => setEditingInteraccion(p => ({ ...p, canal: e.target.value }))}>
                    {canales.map((c) => (
                      <option key={c.id} value={c.nombre.toLowerCase()}>{c.nombre}</option>
                    ))}
                  </select>
                </div>
                <div style={S.formGroup}>
                  <label style={S.label}>Contacto</label>
                  <select style={S.select} value={editingInteraccion.contacto_id || ""} onChange={e => setEditingInteraccion(p => ({ ...p, contacto_id: e.target.value }))}>
                    <option value="">Sin contacto</option>
                    {contactos.map(c => <option key={c.id} value={c.id}>{c.nombre}{c.cargo ? ` — ${c.cargo}` : ""}</option>)}
                  </select>
                </div>
              </div>
              <div style={S.formRow}>
                <div style={{ ...S.formGroup, flex: "1 1 100%" }}>
                  <label style={S.label}>Resumen *</label>
                  <textarea style={S.textarea} value={editingInteraccion.resumen || ""} onChange={e => setEditingInteraccion(p => ({ ...p, resumen: e.target.value }))} required />
                </div>
              </div>
              <div style={S.formRow}>
                <div style={{ ...S.formGroup, flex: "1 1 100%" }}>
                  <label style={S.label}>Próximo paso</label>
                  <textarea style={{ ...S.textarea, minHeight: 50 }} value={editingInteraccion.proximo_paso || ""} onChange={e => setEditingInteraccion(p => ({ ...p, proximo_paso: e.target.value }))} placeholder="Opcional…" />
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10, marginTop: 4 }}>
                <div>
                  {!confirmDeleteInteraccion ? (
                    <button type="button" onClick={() => setConfirmDeleteInteraccion(true)} style={{ padding: "8px 16px", background: "none", border: "1.5px solid #dc2626", borderRadius: 8, color: "#dc2626", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                      Eliminar
                    </button>
                  ) : (
                    <div style={{ display: "flex", alignItems: "center", gap: 8, background: "#fef2f2", border: "1.5px solid #fecaca", borderRadius: 8, padding: "8px 14px" }}>
                      <span style={{ fontSize: 13, color: "#dc2626", fontWeight: 600 }}>¿Confirmar?</span>
                      <button type="button" onClick={handleDeleteInteraccion} style={{ padding: "5px 14px", background: "#dc2626", color: "#fff", border: "none", borderRadius: 6, fontSize: 13, fontWeight: 700, cursor: "pointer" }}>Sí, eliminar</button>
                      <button type="button" onClick={() => setConfirmDeleteInteraccion(false)} style={{ padding: "5px 14px", background: "none", color: "#555", border: "1.5px solid #d1d5db", borderRadius: 6, fontSize: 13, cursor: "pointer" }}>Cancelar</button>
                    </div>
                  )}
                </div>
                <button style={S.submitBtn} type="submit" disabled={savingEditInteraccion}>
                  {savingEditInteraccion ? "Guardando…" : "Guardar cambios"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default CRMDetalleCuenta;
